function o(r){return Array.isArray(r)}export{o as a};
